export default __webpack_public_path__ + "static/Plots0001-4323d74a64cf4428e4b9af671a0f2b03.jpg";